import { z } from 'zod'

export const createCustomShiftNotificationSchema = z.object({
  deliveryHour: z.coerce
    .number({
      required_error: 'Delivery hour is required',
      invalid_type_error: 'Delivery hour must be a number',
    })
    .int('Delivery hour must be a whole number')
    .min(-48, 'Delivery hour must be between -48 and 4')
    .max(4, 'Delivery hour must be between -48 and 4'),
  title: z.string().max(100, 'Title must be 100 characters or fewer'),
  message: z
    .string()
    .min(1, 'Message is required')
    .max(200, 'Message must be 200 characters or fewer'),
})

export type CreateCustomShiftNotificationSchema = z.infer<
  typeof createCustomShiftNotificationSchema
>
